import { RHFNumberText } from '@components/forms/hook-form/rhf-number-field';
import { Table, TableRow, TableHead, TableCell, TableBody } from '@mui/material';
import { t } from 'i18next';
import moment from 'moment';

// Minimal milestone type required for this table
interface MinimalMilestone {
  _id: string;
  milestonePeriod: number;
  paymentDate: Date;
  total: number;
}

export const BillingMilestonesByItemTable = ({
  milestones,
}: {
  milestones: MinimalMilestone[];
}) => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell width="300px" align="center">
            {t('Billing Milestone')}
          </TableCell>
          <TableCell align="center">{t('Billing Date')}</TableCell>
          <TableCell width="200px" align="center">
            {t('Amount To Be Billed')}
          </TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {milestones.map((milestone) => (
          <TableRow key={`milestone-${milestone._id}`}>
            <TableCell align="center">
              {`${t('Billing Milestone ')} ${milestone.milestonePeriod}`}
            </TableCell>
            <TableCell align="center">{moment(milestone.paymentDate).utc().format('LL')}</TableCell>
            <TableCell align="center">
              <RHFNumberText
                value={milestone.total}
                decimalScale={2}
                fixedDecimalScale
                prefix="$ "
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
